<template lang="pug">
    v-btn.btn(
        :loading="isLoading"
        :color="color"
        :outline="outline"
        :flat="flat"
        :small="small"
        :block="block"
        :medium="medium"
        :large="large"
        :class="{'disabled': disabled}"
        @click.prevent="action"
    )
        slot
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            action: VueTypes.func.def(() => {}),
            block: VueTypes.bool.def(false),
            isLoading: VueTypes.bool.def(false),
            disabled: VueTypes.bool.def(false),
            color: VueTypes.string.def('primary'),
            outline: VueTypes.bool.def(false),
            flat: VueTypes.bool.def(false),
            small: VueTypes.bool.def(false),
            medium: VueTypes.bool.def(false),
            large: VueTypes.bool.def(false)
        }
    };
</script>

<style lang="stylus">
    @import '../../assets/style/_variables.styl'

    .btn
        &.v-btn
            min-width: 160px
            box-shadow: none !important
            border-radius: 10px
            padding: 0 35px
            font-weight: 400

        &.disabled
            pointer-events: none
            background-color: #A4A9AE !important


        &.action .v-btn__content
            color: $theme.white

        &.grey
            border-color: $theme-grey


        &.primary:hover
            background-color: lighten($theme.primary, 5%) !important

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .btn
            &.v-btn
                padding: 0 20px
                min-width: calc(100% - 10px)
</style>
